import React, {useEffect, useState} from 'react';
import {Tabs, Typography} from 'antd';
import {
    matchPath,
    Route,
    Routes,
    useLocation,
    useNavigate,
    useParams,
} from 'react-router-dom';
import useTitle from '@/hook/useTitle';
import reportRoutes from './reportRoutes';
import {PieChartOutlined} from '@/icons';

import styles from './index.module.less';

const PARENT_PREFIX = '/apps/:appId/report';

// 父级 <Route path="/apps/:appId/report/*"> 已经消耗了 /apps/:appId/report，
// 子级 <Routes> 必须用相对路径。reportRoutes 里的 path 保持绝对路径用于 navigate/matchPath。
const toRelative = (absPath) => {
    if (absPath === PARENT_PREFIX) {
        return '';
    }
    if (absPath === '*') {
        return '*';
    }
    if (absPath.startsWith(PARENT_PREFIX + '/')) {
        return absPath.slice(PARENT_PREFIX.length + 1);
    }
    return absPath;
};

export default function ReportPage() {
    useTitle('数据统计');
    const navigate = useNavigate();
    const location = useLocation();
    const {appId} = useParams();
    const [activeKey, setActiveKey] = useState(reportRoutes[0].path);
    // Flow parser 不支持 JSX 里写 <reportRoutes[0].Comp />（把 [0] 当成命名空间标记），
    // 这里先取出来再用。
    const FirstReportComp = reportRoutes[0].Comp;

    useEffect(() => {
        const route = reportRoutes.find(({path}) => {
            // react-router v6：matchPath 参数顺序为 (pattern, pathname)
            const m = matchPath({path, end: false}, location.pathname);
            return m && m.pattern.path;
        });
        if (route) {
            setActiveKey(route.path);
        }
    }, [location.pathname]);

    function onTabChange(key) {
        let toPath = key.replace(':appId', appId);
        navigate(toPath);
    }

    const tabLeft = (
        <Typography.Text type="secondary" className={styles.tabsTitle}>
            <PieChartOutlined style={{marginRight: 10}} />
            数据统计
        </Typography.Text>
    );
    return (
        <div className={styles.container}>
            <Tabs
                className={styles.tabs}
                onChange={onTabChange}
                activeKey={activeKey}
                tabBarExtraContent={{left: tabLeft}}
            >
                {reportRoutes.map(({path, label}) => (
                    <Tabs.TabPane key={path} tab={label} />
                ))}
            </Tabs>

            <div className={styles.content}>
                <Routes>
                    {/* index 路由直接渲染第一个 tab 的组件，不再 Navigate 跳到
                        reportRoutes[0].path（'/apps/:appId/report/user_increase'）——
                        那个 path 含字面 :appId，跳过去 react-router 会把 :appId 解析为
                        字面字符串 ":appId"，导致 useParams().appId 和 ajax URL 都
                        带字面 :appId，从而 AppPageWrapper 业务 404 显示"应用不存在" */}
                    <Route
                        index
                        element={<FirstReportComp />}
                    />
                    {reportRoutes.map(({path, Comp}) => (
                        <Route
                            key={path}
                            path={toRelative(path)}
                            element={<Comp />}
                        />
                    ))}
                </Routes>
            </div>
        </div>
    );
}
